import React, { useState, useEffect } from "react";
import { useLayout } from "@/hooks/Layout";

// Component styles:
import "./index.scss";
import { usePageContext } from "@/contexts/Page";

const logo = "/images/gaston-acurios.png";
const logoInter = "/images/logo-internacional.webp";

const allowedSlugs = [
  "san-francisco",
  "bellevue",
  "madrid",
  "dubai",
  "miami",
  "doha",
  "peru",
];

export const WebsCta: React.FC<WebsCtaProps> = () => {
  const { externalWebsites, externalInternational,locations } = useLayout();
  const [showElement, setShowElement] = useState<boolean>(false);
  const { slug } = usePageContext();
  const currentLocation = locations.find((location) => location.slug === slug);

  const laCarta = currentLocation ? currentLocation.section02 : null;
  const laCartaLink = laCarta && slug === "peru" ? laCarta.menuList[0].redirection : '';

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY || document.documentElement.scrollTop;
      const windowHeight = window.innerHeight;

      const documentHeight =
        Math.max(
          document.body.scrollHeight,
          document.body.offsetHeight,
          document.documentElement.clientHeight,
          document.documentElement.scrollHeight,
          document.documentElement.offsetHeight
        ) - windowHeight;

      const isAtTop = scrollTop === 0;
      const isAtBottom = scrollTop >= documentHeight - 150;
      setShowElement(isAtTop || isAtBottom);
    };

    handleScroll();
    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const websitesToRender =
    slug === "peru" ? externalWebsites : externalInternational;

  const render = slug ? allowedSlugs.includes(slug.toLowerCase()) : false;

  if (!render) {
    return null;
  }

  return (
    <>
      <div className={`webs-cta-container ${showElement ? "show" : ""}`}>
        <div className="container-fluid">
          <div className="row">
            <div className="col-lg-2 webs-cta-container__logo">
              {slug === "peru" ? (
                <img
                  className="logo-image"
                  src={logo}
                  title={"Gastón Acurios"}
                  alt={"Logo - Gastón Acurios."}
                />
              ) : (
                <img
                  className="logo-image"
                  src={logoInter}
                  title={"Gastón Acurios"}
                  alt={"Logo - Gastón Acurios."}
                />
              )}
            </div>

            <div className="col-lg-10">
              <ul className="webs-cta-container__elements">
                {websitesToRender ? (
                  websitesToRender.map((web, index) => (
                    <li className="element" key={index}>
                      <img
                        className="element__image"
                        src={web.websiteImage.node.publicUrl}
                        alt={web.websiteImage.node.altText}
                        title={web.websiteImage.node.title}
                      />
                      <a
                        className="element__redirection redirection-button"
                        rel="noopener noreferrer"
                        href={web.websiteRedirection}
                        target="_blank"
                      ></a>
                    </li>
                  ))
                ) : (
                  <></>
                )}
              </ul>
            </div>
          </div>
        </div>
      </div>

      {slug === "peru" ? (
        <section
          className={`bookins-cta-container ${showElement ? "show" : ""}`}
        >
          <div className="button-container flex justify-center">
            <a
              href={laCartaLink}
              className="cta__button redirection-button"
              target="_blank"
            >
              <button type="button" className="button style-primary-dark">
                Carta
              </button>
            </a>
          </div>
        </section>
      ) : (
        <></>
      )}
    </>
  );
};
